"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ui = require("@unite-us/ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var EditField = function EditField(props) {
  var FieldComponent = props.FieldComponent,
    fieldMeta = props.fieldMeta,
    fieldProps = props.fieldProps,
    id = props.id,
    isSaving = props.isSaving,
    label = props.label,
    onBlur = props.onBlur,
    onCancelEdit = props.onCancelEdit,
    onChange = props.onChange,
    onSaveEdit = props.onSaveEdit,
    setFieldRef = props.setFieldRef,
    value = props.value,
    afterLabelContent = props.afterLabelContent;
  var controlsClass = function controlsClass() {
    return (0, _classnames["default"])({
      'ui-inline-edit__label__controls': true,
      'ui-inline-edit__label__controls--saving': isSaving
    });
  };
  var labelWIthControls = function labelWIthControls() {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "ui-inline-edit__label"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "ui-inline-edit__label__container"
    }, label), /*#__PURE__*/_react["default"].createElement("div", {
      className: controlsClass()
    }, /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      icon: "IconCross",
      className: "ui-inline-edit__label__controls__cancel",
      onClick: onCancelEdit,
      id: "".concat(id, "-cancel-btn"),
      color: "white",
      ariaLabel: "Cancel",
      size: 18,
      disabled: isSaving
    }), /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      icon: "IconCheck",
      className: "ui-inline-edit__label__controls__save",
      onClick: onSaveEdit,
      id: "".concat(id, "-save-btn"),
      color: "white",
      ariaLabel: "Save",
      size: 18,
      disabled: isSaving
    }))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "ui-inline-edit__after-label-content"
    }, afterLabelContent));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-inline-edit-field__edit ui-inline-edit"
  }, /*#__PURE__*/_react["default"].createElement(FieldComponent, _extends({
    ref: setFieldRef,
    id: "".concat(id, "-field"),
    label: labelWIthControls(),
    value: value,
    onChange: onChange,
    onBlur: onBlur
  }, fieldProps, fieldMeta)));
};
EditField.propTypes = {
  afterLabelContent: _propTypes["default"].node,
  FieldComponent: _propTypes["default"].func.isRequired,
  fieldMeta: _propTypes["default"].object.isRequired,
  fieldProps: _propTypes["default"].object.isRequired,
  id: _propTypes["default"].string.isRequired,
  isSaving: _propTypes["default"].bool.isRequired,
  label: _propTypes["default"].string.isRequired,
  onBlur: _propTypes["default"].func.isRequired,
  onCancelEdit: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  onSaveEdit: _propTypes["default"].func.isRequired,
  setFieldRef: _propTypes["default"].func.isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object]).isRequired
};
EditField.defaultProps = {
  afterLabelContent: null
};
var _default = exports["default"] = EditField;